import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import { useGetInscritosEidu } from "hooks/useRequest";
import { Mutation } from "hooks/useMutation";
import { ExportToCsv } from "export-to-csv";
import { eliminarDocente } from "containers/Admin/ListaMatriculados/mutations";

function siNo(value: boolean | null | undefined) {
  if (value === true) return "Sí";
  if (value === false) return "No";
  return "";
}

function tallerDe(docente: any) {
  const nombres = (docente?.matriculadoSet ?? [])
    .map((matriculado: any) => matriculado?.grupo?.nombre)
    .filter(Boolean);
  return nombres.join(", ");
}

export const useListaInscritosEidu = () => {
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [filteredDataDocente, setFilteredData] = useState<any[]>([]);
  const history = useHistory();

  const { search } = useLocation();
  const { periodo } = queryString.parse(search);
  const periodoId = parseInt(String(periodo), 10);

  const { data, isLoading, isFetching, refetch } = useGetInscritosEidu({
    id: periodoId,
  });

  const mutation = Mutation(eliminarDocente, refetch);

  const handleOnEdit = (id: any) => {
    history.push({
      pathname: `/admin/editar-docente`,
      search: `?docente=${id}&periodo=${periodo}&lista=inscritos`,
    });
  };

  const handleDelete = (id: any) => {
    setDeleteModalVisible(true);
    setSelectedId(id);
  };

  const handleOkDelete = () => {
    if (selectedId == null) return;
    /*@ts-ignore*/
    mutation.mutate({ id: selectedId });
    setDeleteModalVisible(false);
  };

  const handleCancelDelete = () => {
    setDeleteModalVisible(false);
    setSelectedId(null);
    refetch();
  };

  const handleGoBack = () => {
    history.push({
      pathname: "/admin/periodo-matricula",
      search: `?periodo=${periodo}`,
    });
  };

  const handleExport = () => {
    const rows = (filteredDataDocente ?? []).map((docente: any) => ({
      Nombre: docente.nombre ?? "",
      Identificación: docente.identificacion ?? "",
      País: docente.pais ?? "",
      "Correo de contacto": docente.correoInstitucional ?? "",
      Teléfono: docente.telefono ?? "",
      "Perteneciente a": docente.universidad ?? "",
      "Unidad Académica": docente.unidad ?? "",
      "Programa / Carrera": docente.carrera ?? "",
      Taller: docente.taller ?? "",
      "Tiene discapacidad": siNo(docente.tieneDiscapacidad),
      "Tipo de discapacidad": docente.tipoDiscapacidad ?? "",
      "Requiere apoyo": siNo(docente.requiereApoyo),
      "Detalle de apoyo": docente.detalleApoyo ?? "",
    }));

    const csvExporter = new ExportToCsv({
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: true,
      filename: `lista-inscritos-eidu-${data?.nombre ?? periodo}`,
      title: `Lista de inscritos EIDU — ${data?.nombre ?? ""}`,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    });
    csvExporter.generateCsv(rows);
  };

  useEffect(() => {
    const mapped = (data?.docenteSet ?? []).map((docente: any) => ({
      ...docente,
      taller: tallerDe(docente),
    }));
    setFilteredData(mapped);
  }, [data]);

  return {
    data,
    filteredDataDocente,
    isLoading,
    isFetching,
    isDeleteModalVisible,
    handleCancelDelete,
    handleOnEdit,
    handleDelete,
    handleGoBack,
    handleOkDelete,
    handleExport,
  };
};
